import React from "react";
import { postcodeValidator, postcodeValidatorExistsForCountry } from "postcode-validator";
import countries from "../../../countries.json";
import { LocalInfo } from "../where-to-buy-form/interfaces";
import { setStorage, getStorage } from "../../../localStorage.service";

const LOCAL_STORAGE_KEY = "localInfo";

interface Props {
  buttonText: string;
  onSubmit: (event: any) => void;
  onZipcodeChange: (event: any) => void;
  onCountryChange: (event: any) => void;
  className: string;
  formLocation: string;
}

class WhereToBuyForm extends React.Component<Props> {
  country: string;
  zipcode: number;
  zipcodeEle: any;
  countryEle: any;

  constructor(props: Props) {
    super(props);

    this.state = {
      error: false,
      errorMessage: ""
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleZipcode = this.handleZipcode.bind(this);
    this.handleCountry = this.handleCountry.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ error: nextProps.error });
  }

  handleSubmit(event) {
    this.setState({ error: false });

    if (!this.zipcodeEle.value) {
      event.preventDefault();
      this.setState({ error: true });
      return;
    } else if (postcodeValidatorExistsForCountry(this.countryEle.value)) {
      if (!postcodeValidator(this.zipcodeEle.value, this.countryEle.value)) {
        event.preventDefault();
        this.setState({ error: true, errorMessage: "Invalid Zip/Postal Code" });
        return;
      }
    }

    const country = countries.find((c) => c.value === this.countryEle.value);
    const value = `${this.zipcodeEle.value} | ${country?.text || this.countryEle.value}`;
    // @ts-ignore
    window?.dataLayer?.push({ event: "where-to-buy", query: value });

    window?.fathom?.trackEvent("Where to Buy", {
      value: value
    });
    this.props.onSubmit(event);
  }

  handleZipcode(event) {
    this.props.onZipcodeChange(event);
  }

  handleCountry(event) {
    this.props.onCountryChange(event);
  }

  componentDidMount() {
    const ev1 = new Event("change", { bubbles: true });
    const ev2 = new Event("change", { bubbles: true });

    this.countryEle.dispatchEvent(ev1);
    this.zipcodeEle.dispatchEvent(ev2);
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <fieldset>
          <label htmlFor={`${this.props.formLocation}-postal-code`}>Zip/Postal Code</label>
          <input
            ref={(input) => (this.zipcodeEle = input)}
            id={`${this.props.formLocation}-postal-code`}
            name="zipcode"
            type="text"
            value={this.zipcode}
            onChange={this.handleZipcode}
            placeholder="Zip or Postal Code"
            className={(this.state?.errorMessage || "").includes("Zip") ? "with-error" : ""}
            required={true}
          />
        </fieldset>
        <fieldset>
          <label htmlFor={`${this.props.formLocation}-country`}>Country</label>
          <select
            ref={(input) => (this.countryEle = input)}
            id={`${this.props.formLocation}-country`}
            aria-label="Country"
            value={this.country}
            onChange={this.handleCountry}
          >
            {countries.map((country, index) => {
              return (
                <option value={country.value} key={`${country.text}-${index}`}>
                  {country.text}
                </option>
              );
            })}
          </select>
        </fieldset>
        <div className={`${this.props.className}`}>
          <button className="btn" type="submit">
            {this.props.buttonText}
          </button>
          <div className="feedback">
            {/* @ts-ignore */}
            {this.props?.loading && <div className="spinner mt-2">Loading</div>}

            {/* @ts-ignore */}
            {(this.props?.error || this.state?.error) && (
              <div className="text-center mt-2">
                <small>
                  {this.state?.errorMessage || "There was a problem. Please try again."}
                </small>
              </div>
            )}
          </div>
        </div>
      </form>
    );
  }
}

export const getLocalInfo = async (zip?, country?): Promise<any> => {
  return new Promise((res, rej) => {
    setTimeout(() => {
      const cachedLocalInfo = getStorage(LOCAL_STORAGE_KEY);

      if (JSON.stringify(cachedLocalInfo) === JSON.stringify({})) {
        const params = [
          ["script", "133"],
          ["deploy", "1"],
          ["compid", "605399"],
          ["ns-at", "AAEJ7tMQGW3NpeE4u3rco0G3xsapsq0SJoKOyn7gIIcMvRkQ9MY"],
          ["brand", process.env.NETSUITE_BRAND],
          ["country", country],
          ["postalCode", zip]
        ];
        const url = `${process.env.FUNCTIONS_URL}.netlify/functions/netsuite?${new URLSearchParams(
          params
        ).toString()}`;

        try {
          fetch(url)
            .then((response) => response.text())
            .then((responseData) => {
              let data = {};
              try {
                const jsonData = JSON.parse(responseData);
                if (jsonData && typeof jsonData === "object") {
                  data = {
                    contact: `${jsonData.contactFirstName} ${jsonData.contactLastName}`,
                    email: jsonData.contactEmail,
                    phone: jsonData.contactPhone.replaceAll(" ", "-"),
                    zipcode: zip,
                    company: jsonData.companyName,
                    companyId: jsonData.companyId
                  };
                  if (jsonData.contactURL && jsonData.contactURL !== "") {
                    data["website"] = jsonData.contactURL;
                  }
                  setStorage(LOCAL_STORAGE_KEY, data);
                  res(data);
                }
              } catch (err) {
                rej(err);
              }
            })
            .catch((err) => {
              rej(err);
            });
        } catch (err) {
          rej(err);
        }
      } else {
        res(cachedLocalInfo as LocalInfo);
      }
    }, 500);
  });
};

export default WhereToBuyForm;
